import React, { useEffect, useState } from 'react';
import { StyledLottiePlayer } from './LottiePlayer.style';

const LottiePlayer = ({
  animationData,
  animationUrl,
  fillContainer = false,
  preserveAspectRatio = fillContainer ? 'xMidYMid slice' : 'xMidYMid meet',
  loop = false,
  play = true,
}: LottiePlayerProps) => {
  const [loading, setLoading] = useState(!animationData);
  const [fetchedAnimationData, setFetchedAnimationData] = useState({});

  useEffect(() => {
    if (!animationData && animationUrl) {
      setLoading(true);
      void fetch(animationUrl)
        .then((response) => response.json())
        .then((response) => {
          setFetchedAnimationData(response);
          setLoading(false);
        });
    }
  }, [animationData, animationUrl]);

  if (loading) {
    return <div>Loading animation...</div>;
  }

  return (
    <StyledLottiePlayer
      animationData={animationData || fetchedAnimationData}
      loop={loop}
      play={play}
      rendererSettings={{
        preserveAspectRatio,
        progressiveLoad: true,
      }}
      fillContainer={fillContainer}
    />
  );
};

export type LottiePlayerProps = {
  animationData?: object;
  animationUrl?: string;
  fillContainer?: boolean;
  loop?: boolean;
  play?: boolean;
  preserveAspectRatio?: string;
};

export default LottiePlayer;
